import { breakpoints, palette, typography } from '@livable/saas-react-components';
import { createTheme } from '@mui/material/styles';
import components from './components';
const theme = createTheme({
  breakpoints,
  components,
  palette,
  shape: {
    borderRadius: 2
  },
  spacing: 1,
  typography
});
export default theme;